import { mainnet } from 'viem/chains'


const embarkyConfig = {
  appId: '82401d2299ffa1da625b',
  theme: 'dark',
  defaultChain: mainnet,
  supportedChains: [mainnet],
}

export const darConfig = {
  clientId: '24331c93f8fd1a42b5a46fbcd34abbdb6ccd377e41d94f9d5138407d4c3163e1',
  clientSecret: '3CPzpDduxZYAVBCcV7bqhd2r7co8c7Beu3RqTUNjj2psDXSEhiCTyPpJRyzPMccHdnzAnYWp8nSYgMGjAnLpchqU',
  authUrl: 'https://testauth.dalarnia.com',
}

export default embarkyConfig
